var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeroSection'),_c('SocialProof'),_c('ImageGrid'),_c('FeaturesGrid'),_c('HowItWorks'),_c('Testimonials'),_c('CtaBanner'),_c('StatsBanner'),_c('PricingSection'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }